<template>
  <div>
    <v-row>
      <v-col cols="6" sm="4">
        <label>عنوان:</label>
        <strong>{{ selectedToSeeDetail.title }}</strong>
      </v-col>

      <v-col cols="6" sm="4">
        <label>مدت اشتراک:</label>
        <strong>{{ selectedToSeeDetail.durationInMonth }} ماه</strong>
      </v-col>

      <v-col cols="6" sm="4">
        <label>وضعیت:</label>
        <strong>{{ selectedToSeeDetail.disabled ? 'غیرفعال' : 'فعال' }}</strong>
      </v-col>
      <v-col cols="6" sm="4" v-if="selectedToSeeDetail.totalPrice">
        <label>قیمت:</label>
        <strong
          >{{ selectedToSeeDetail.totalPrice.amount | priceSplitter
          }}{{ selectedToSeeDetail.totalPrice.currency }}</strong
        >
      </v-col>
      <v-col cols="12" sm="6">
        <label>تاریخ:</label>
        <strong>
          از {{ selectedToSeeDetail.startDateUtc | moment }} تا
          {{ selectedToSeeDetail.endDateUtc | moment }}</strong
        >
      </v-col>
      <v-col cols="12" v-if="selectedToSeeDetail.description">
        <label> توضیحات:</label>
        <strong>{{ selectedToSeeDetail.description }}</strong>
      </v-col>
    </v-row>
    <div
      class="w-100 d-flex justify-content-center mt-3"
      v-if="selectedToSeeDetail.items.length && showItem"
    >
      <v-sheet outlined>
        <v-data-table
          disable-pagination
          hide-default-footer
          :items="selectedToSeeDetail.items"
          :headers="itemsHeader"
        >
          <template v-slot:[`item.serviceType`]="{ item }">
            {{ serviceTypeDisplayName(item.serviceType) }}
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ item.price | priceSplitter }} ریال
          </template>
          <template v-slot:[`item.description`]="{ item }">
            {{
              item.description.length > 30
                ? item.description.slice(0, 30) + '...'
                : item.description
            }}
          </template>
        </v-data-table>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { GET_ENUMS } from '../../../enums/store/types';
export default {
  mixins: [reusableMethodsMixin],
  props: {
    selectedToSeeDetail: {
      type: Object,
      default: null,
    },
    showItem: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      serviceTypeList: [],
      itemsHeader: [
        { text: 'عنوان', value: 'title' },
        { text: 'نوع خدمت', value: 'serviceType' },
        { text: 'تعداد', value: 'amount' },
        { text: 'قیمت', value: 'price' },
        { text: 'توضیحات', value: 'description' },
      ],
    };
  },
  async created() {
    if (!this.$store.getters.allEnums.length) {
      await this.$store.dispatch(GET_ENUMS);
    }
    this.serviceType();
  },
  methods: {
    serviceTypeDisplayName(title) {
      if (this.serviceTypeList.length) {
        let result = this.serviceTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    serviceType() {
      this.serviceTypeList = this.getEnumByTitle('ServiceType');
    },
  },
};
</script>

<style></style>
